import React from 'react';
import { Icon } from './Icon.js';
export const IconFileVideo = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M19 18.5L22 17V20L19 18.5314", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" }),
        React.createElement("path", { d: "M19 15H12V22H19V15Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M12 2V10H4", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M20 11V2H10.5919L4 8.58984V22H8", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" })));
};
//# sourceMappingURL=IconFileVideo.js.map